var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCustomHtmlCode = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 70,
  height: 40,
  viewBox: "0 0 70 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1 5C1 2.79086 2.79086 1 5 1H55.5858L69 14.4142V35C69 37.2091 67.2091 39 65 39H5C2.79086 39 1 37.2091 1 35V5Z",
  stroke: "currentColor",
  strokeWidth: 2,
  fill: "transparent"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M26.8717 27.04L19.4117 21.98V20.74L26.8717 15.68V17.26L20.8517 21.32V21.4L26.8717 25.46V27.04ZM30.9839 31.2L37.5439 13.8H39.0239L32.4639 31.2H30.9839ZM43.1361 27.04V25.46L49.1561 21.4V21.32L43.1361 17.26V15.68L50.5961 20.74V21.98L43.1361 27.04Z",
  fill: "currentColor"
})));
export default SvgCustomHtmlCode;